import { USER_STATUS } from '@/views/Facilities/UserManagement/components/userHistory.utils';

const FacilityUserStatusText = ({ status, children }) => {
  const color = status === USER_STATUS.INACTIVE ? 'grey' : 'inherit';

  return <span style={{ color }}>{children}</span>;
};

export default FacilityUserStatusText;
